import { render } from "./DataPanel.vue?vue&type=template&id=3c53f6d2"
import script from "./DataPanel.vue?vue&type=script&lang=js"
export * from "./DataPanel.vue?vue&type=script&lang=js"

import "./DataPanel.vue?vue&type=style&index=0&id=3c53f6d2&lang=css"
script.render = render

export default script